import React from 'react';
import { useTranslation } from "react-i18next";
import HeroSection from '../../components/sections/HeroSection';
import FooterSection from '../../components/sections/FooterSection';
import DividersInfoSection from '../../components/sections/DividersInfoSection';
import FaqAccordionsSection from '../../components/sections/FaqAccordionsSection';
import FactsAndStatsSection from '../../components/sections/FactsAndStatsSection';
import BigTinyIntroSection from '../../components/sections/BigTinyIntroSection';
import ParallaxCallSection from '../../components/sections/ParallaxCallSection';

function TurkistanCityPage(props) {

    var { t } = useTranslation();

    var faqItems = [
        { question: "What documents are required?", answer: "Passport valid for at least 6 months, visa application form, passport photos, proof of accommodation, and travel insurance are standard requirements." },
        { question: "How long does processing take?", answer: "Standard processing usually takes up to 5 working days, while express processing can be completed in 48 hours depending on consular workload." },
        { question: "Can business delegations apply?", answer: "Yes, corporate visa packages are available for delegations, including bulk submissions, account-based invoicing, and consolidated document delivery." },
        { question: "Is visa on arrival available?", answer: "Visa on arrival is limited to specific cases. Pre-application ensures guaranteed entry and avoids administrative delays at the border." }
    ];

    return (
        <>
            <HeroSection
                isExpectingAnimations={true}
                i18nTitleKey="infopages.cities.turkistan.title"
                i18nParagraphKey="infopages.cities.turkistan.paragraph1"
                i18nCallToActionKey="infopages.cities.turkistan.cta"
                backgroundImageUrl="https://kz24.news/wp-content/uploads/2024/05/dostoprimechatelnosti-turkestana.jpg"
            />

            <div className='uk-container uk-section'>
                <BigTinyIntroSection
                    Big="Turkistan, a historic city in southern Kazakhstan, is renowned for its rich cultural heritage and significant religious landmarks. As one of the oldest cities in the region, Turkistan has been a vital center for trade, culture, and spirituality for centuries. The city is most famous for the Mausoleum of Khoja Ahmed Yasawi, a UNESCO World Heritage site that attracts pilgrims and tourists from around the world. This architectural masterpiece, built in the 14th century, is a testament to the city's historical importance as a spiritual hub in Central Asia."
                    Tiny="In addition to its religious significance, Turkistan boasts a vibrant local culture, with traditional crafts, music, and cuisine that reflect the diverse influences that have shaped the city over time. The city's markets are filled with colorful textiles, intricate pottery, and other handmade goods that showcase the skills of local artisans. With its blend of historical significance and contemporary culture, Turkistan offers visitors a unique glimpse into the rich tapestry of Kazakhstan's past and present."
                />
            </div>

            <ParallaxCallSection
                URL="https://cdn.nur.kz/images/1200x675/cfb1949e5ccbee20.jpeg?version=1"
                headline="Rediscover Spiritual Heritage in Turkistan"
                callToAction="Begin your visa process today and step into the heart of ancient Silk Road history, where culture, faith, and hospitality meet."
            />

            {/* Quick Facts / Statistics */}
            <FactsAndStatsSection
                sectionTitle="Quick Facts"
                stat1="90%"
                fact1="Visa approval rate"
                stat2="635+"
                fact2="Clients served"
                stat3="14"
                fact3="Days processing time"
                stat4="1960"
                fact4="Year city founded"
            />

            {/* FAQ Accordion */}
            <FaqAccordionsSection
                items={faqItems}
            />

            <div className='uk-container'>
                {/* Infosection with shitloads of dividers */}
                <DividersInfoSection />
            </div>

            <FooterSection />
        </>
    );
}

export default TurkistanCityPage;